import React, { useContext } from 'react';
import unitConverter from 'convert-units';
import { Translation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { sluggify } from 'utils/localization/utils';
const nameFormatter = (cell, row) => {
    return (React.createElement(Translation, null, (t) => (React.createElement("span", { style: { color: '#337ab7', cursor: 'pointer' } }, t(sluggify(cell))))));
};
const distanceFormatter = (cell) => {
    return unitConverter(cell).from('mi').to(DEFAULT_DISTANCE_UNITS).toFixed(2);
};
const activeMarketFormatter = (cell) => {
    if (cell) {
        return (React.createElement(Translation, null, (t) => React.createElement("span", null, titleize(t('YES')))));
    }
    return React.createElement(Translation, null, (t) => React.createElement("span", null, titleize(t('NO'))));
};
const columns = [
    {
        dataField: 'name',
        text: 'Name',
        localizationSlug: 'NAME',
        sort: true,
        formatter: nameFormatter,
        headerStyle: {
            width: '8%',
        },
    },
    {
        dataField: 'code',
        text: 'Code',
        localizationSlug: 'CODE',
        sort: true,
        type: 'generic',
        headerStyle: {
            width: '8%',
        },
    },
    {
        dataField: 'distribution_radius',
        text: 'Distribution Radius',
        localizationSlug: 'DISTRIBUTION_RADIUS',
        sort: true,
        headerStyle: {
            width: '5%',
        },
        formatter: distanceFormatter,
    },
    {
        dataField: 'max_shipment_distance',
        text: 'Max Shipment Distance',
        localizationSlug: 'MAX_SHIPMENT_DISTANCE',
        sort: true,
        headerStyle: {
            width: '5%',
        },
        formatter: distanceFormatter,
    },
    {
        dataField: 'active',
        text: 'Active',
        localizationSlug: 'ACTIVE',
        titleize: true,
        sort: true,
        formatter: activeMarketFormatter,
        headerStyle: {
            width: '5%',
        },
    },
];
export default {
    columns,
};
